import React from "react";
import { Button } from "@hid-galaxy-ui/galaxy-react";
import "./ActionButtons.scss";

type ActionButtonsVariant = "full" | "minimal";

interface ActionButtonsProps {
  isHIDUser: boolean;
  // ========== TEMPORARY: Data entry partner view - start (remove with TEMPORARY block) ==========
  /** When true (e.g. data-entry user swetha.patnam@hidglobal.com), show "Complete environment details" like partner. */
  isDataEntryPartnerView?: boolean;
  // ========== TEMPORARY: Data entry partner view - end ==========
  environmentActionDisabled?: boolean;
  variant?: ActionButtonsVariant;
  onGuidanceClick?: () => void;
  onSummaryClick: () => void;
  onHistoryClick?: () => void;
  onEnvironmentDetailsClick: () => void;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  isHIDUser,
  // ========== TEMPORARY: remove isDataEntryPartnerView when removing data-entry partner view ==========
  isDataEntryPartnerView = false,
  environmentActionDisabled = false,
  variant = "full",
  onGuidanceClick,
  onSummaryClick,
  onHistoryClick,
  onEnvironmentDetailsClick,
}) => {
  // ========== TEMPORARY: show "Complete environment details" for partner OR data-entry user. Revert to: (isHIDUser ? "Verify..." : "Complete...") ==========
  const showCompleteEnvironmentDetails = !isHIDUser || isDataEntryPartnerView;
  return (
    <div className="action-buttons-container">
      {variant === "full" && onGuidanceClick && (
        <Button
          variant="flat"
          label="Guidance process and steps"
          normalCase={true}
          onClick={onGuidanceClick}
        />
      )}
      <Button
        variant="flat"
        label="View summary"
        normalCase={true}
        onClick={onSummaryClick}
      />
      {variant === "full" && onHistoryClick && (
        <Button
          variant="flat"
          label="Validation history"
          normalCase={true}
          onClick={onHistoryClick}
        />
      )}
      {/* TEMPORARY: uses showCompleteEnvironmentDetails for data-entry user. Revert label to: (isHIDUser ? "Verify Environment details" : "Complete environment details") */}
      <Button
        variant={variant === "full" ? "primary" : "flat"}
        label={variant === "full"
          ? (showCompleteEnvironmentDetails ? "Complete environment details" : "Verify Environment details")
          : "View Environment Details"
        }
        normalCase={true}
        onClick={onEnvironmentDetailsClick}
        disabled={environmentActionDisabled}
      />
    </div>
  );
};

export default ActionButtons;

